import { defineTranslateKeys } from 'lib/tolgee'

export default defineTranslateKeys({
  alignLeft: {
    defaultValue: 'Alinhar à esquerda',
    key: 'text-toolbar-alignLeft',
  },
  alignRight: {
    defaultValue: 'Alinhar à direita',
    key: 'text-toolbar-alignRight',
  },
  alignCenter: {
    defaultValue: 'Centralizar',
    key: 'text-toolbar-alignCenter',
  },
  alignJustify: {
    defaultValue: 'Justificar',
    key: 'text-toolbar-alignJustify',
  },
  undo: {
    defaultValue: 'Desfazer',
    key: 'text-toolbar-undo',
  },
  redo: {
    defaultValue: 'Refazer',
    key: 'text-toolbar-redo',
  },
  bold: {
    defaultValue: 'Negrito',
    key: 'text-toolbar-bold',
  },
  italic: {
    defaultValue: 'Itálico',
    key: 'text-toolbar-italic',
  },
  underscore: {
    defaultValue: 'Sublinhado',
    key: 'text-toolbar-underscore',
  },
  insertLink: {
    defaultValue: 'Insira o link',
    key: 'text-toolbar-insertLink',
  },
  textColor: {
    defaultValue: 'Cor da fonte',
    key: 'text-toolbar-textColor',
  },
  highlightColor: {
    defaultValue: 'Cor do fundo',
    key: 'text-toolbar-highlightColor',
  },
})
